import { openModal } from "./modal";

const modalsRegex = /^(https:\/\/[^/]+)?\/((da|en)\/)?modals\/(?<name>.+)\/?$/i;

export function initModalLinks() {
    document.addEventListener("click", (evt) => {
        const elm = (evt.target as HTMLElement).closest(
            "a",
        ) as HTMLAnchorElement;
        if (!elm) {
            return;
        }

        const m = modalsRegex.exec(elm.href);
        if (!m) {
            return;
        }

        const name = m.groups?.["name"];
        if (!name) {
            console.error("Error in matching modal name");
            return;
        }

        openModal({
            name,
        });
        evt.preventDefault();
    });
}
